exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".confirm {\n  width: 580px; }\n\n.confirmation-message {\n  font-size: 18px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Source/Ecim/Ecim.Web/src/app/components/we-got-your-application/we-got-your-application.component.scss
// module id = ../../../../../src/app/components/we-got-your-application/we-got-your-application.component.scss
// module chunks = main